import { Grid, Typography } from '@mui/material';
import { useStyles } from '../style';

// کامپوننت از نوع برداشت وجه
export default function WithrawComponent({ data }) {
  const classes = useStyles();

  return (
    <Grid container direction="row" alignItems="center" item>
      <Grid item xs={12}>
        <Grid container xs={12} md={12} className={classes.info}>
          {data.map((item, index) => {
            return (
              item.isShow &&
              <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                <Typography className={classes.detailTitle}>{item.titleFa}</Typography>
                <Typography className={classes.detailValue}>{item.value}</Typography>
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    </Grid>
  );
}
